module.exports = __webpack_public_path__ + "icomoon.17d00.svg";